import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";
import "dayjs/locale/ja";
export default {
  name: "master-holiday",
  components: {
    AppHeader
  },
  async created() {
    await this.getCompany();
    await this.getHoliday();
  },
  data() {
    return {
      companies: "",
      holidays: [],
      selectedCompany: localStorage.company_id,
      getCompaniesEnd: false,
      getHolidaysEnd: false
    };
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompaniesEnd = true;
    },
    async getHoliday() {
      this.getHolidaysEnd = false;
      let data = {
        company_id: this.selectedCompany
      };
      let res = await this.$store
        .dispatch("GET_HOLIDAY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.holidays = res.holidays;
      this.getHolidaysEnd = true;
    },
    goHolidayEdit(holidayId) {
      this.$router.push({ path: `/master_holiday/${holidayId}/edit` });
    },
    async deleteHoliday(holidayId) {
      if (!window.confirm("本当に削除しますか？")) {
        return;
      }
      let res = await this.$store
        .dispatch("DELETE_HOLIDAY", {
          id: holidayId,
          data: {}
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (!res.error) {
        this.getHoliday();
      }
    },
    formatHolidayDate(date) {
      dayjs.locale("ja");
      return dayjs(date).format("YYYY年MMMMD日" + "(" + "ddd" + ")");
    }
  }
};
